import { useNavigate } from 'react-router-dom';
import VolunteerScientistsDetailsView from './VolunteerScientistsDetailsView';
import { ParagraphHeader } from '@seims/shared';
import { RenderAuthenticated } from "@seims/shared/src/security";

export default function VolunteerHomeView() {
  const navigate = useNavigate()
  return (
    <>
      <ParagraphHeader header="Volunteer Scientists/STEM Professionals - My Profile" />
      <RenderAuthenticated>
        <VolunteerScientistsDetailsView />
      </RenderAuthenticated>
    </>
  );
}
